module.exports = "pegasus_template/assets/coupon-preview.png";